import React from "react";
export class DisplayCard extends React.Component {
  render() {
    var cls = 'display-card';
    if (this.props.cls) cls += ' ' + this.props.cls;
    // Optional {text, dir} delta chip (dir: 'up' | 'down' | 'flat') —
    // % change vs the prior window, used by the Territory/Product KPIs.
    var delta = this.props.delta;
    var deltaColor = delta && (delta.dir === 'up' ? '#16a34a' : delta.dir === 'down' ? '#dc2626' : '#737373');
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, /*#__PURE__*/React.createElement("div", {
      className: "label"
    }, this.props.label), /*#__PURE__*/React.createElement("div", {
      className: "value"
    }, this.props.value), delta ? /*#__PURE__*/React.createElement("div", {
      className: "delta",
      style: {
        fontSize: '12px',
        marginTop: '2px',
        fontWeight: 600,
        color: deltaColor
      }
    }, delta.dir === 'up' ? '▲ ' : delta.dir === 'down' ? '▼ ' : '', delta.text) : null);
  }
}
export class CustomDisplayCard extends React.Component {
  render() {
    var cls = 'display-card';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export class CardLayout extends React.Component {
  render() {
    var cls = 'card-layout';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export class ChartCardLayout extends React.Component {
  render() {
    var cls = 'chart-card-layout';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children);
  }
}
export class ChartCard extends React.Component {
  render() {
    var cls = 'body';
    if (this.props.cls) {
      cls += ' ' + this.props.cls;
    }
    let mainCls = 'chart-card';
    if (this.props.mainCls) {
      mainCls += ' ' + this.props.mainCls;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: mainCls
    }, /*#__PURE__*/React.createElement("span", null, this.props.title), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
      className: cls
    }, this.props.children));
  }
}
export class CardFlexRow extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "card-flex-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-label"
    }, this.props.label, ":"), /*#__PURE__*/React.createElement("div", null, this.props.value));
  }
}
export default {
  DisplayCard,
  CustomDisplayCard,
  CardLayout,
  ChartCardLayout,
  ChartCard,
  CardFlexRow
};
// KPI strip — the contact-UX redesign tile design (joined grid, hairline
// separators, value-over-label, tabular numerals). Styles: sass/v2/_kpi.scss.
export class KpiStrip extends React.Component {
  render() {
    var cls = 'plk-kpis';
    if (this.props.cls) cls += ' ' + this.props.cls;
    return /*#__PURE__*/React.createElement("div", {
      className: cls,
      style: this.props.style
    }, this.props.children);
  }
}
export class Kpi extends React.Component {
  render() {
    // delta: {text, dir} — same shape DisplayCard takes (deltaOf()).
    var delta = this.props.delta;
    return /*#__PURE__*/React.createElement("div", {
      className: "plk-kpi"
    }, /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, this.props.value), /*#__PURE__*/React.createElement("div", {
      className: "l"
    }, this.props.label), delta ? /*#__PURE__*/React.createElement("div", {
      className: 'd ' + (delta.dir || 'flat')
    }, delta.dir === 'up' ? '▲ ' : delta.dir === 'down' ? '▼ ' : '', delta.text) : null);
  }
}